/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * GroupTenFrame.tsx - Grouped Ten Frame layout.
*/

import { StyleSheet, View } from 'react-native';
import { calculateVerticalTenFrameSize } from './TenFrameSizes';
import Square from './TenFrameElement';

import type { JSX } from 'react';

export interface GroupTenFrameProps {
  numFrames: number;
  numReds: number;
  numYellows: number;
  usableWidth: number;
  usableHeight: number;
}

const GroupTenFrame = ({numFrames, numReds, numYellows, usableWidth, usableHeight}: GroupTenFrameProps): JSX.Element => {

  const { usableElementSize, elementMargin } = calculateVerticalTenFrameSize(numFrames, usableWidth, usableHeight);
  
  const rows: JSX.Element[] = [];

  let numRedsTop = Math.ceil(numReds/2);
  let numRedsBottom = Math.floor(numReds/2);

  let numYellowsTop = Math.ceil(numYellows/2);
  let numYellowsBottom = Math.floor(numYellows/2);  

  const topRowCols: JSX.Element[] = [];
  // Put in the top row
  for (let i = 0; i < 5; i++) {
    if(i % 2 === 0 && numYellowsTop > 0)
    {
      topRowCols.push(
        <Square color="yellow" isFilled key={`topyellow${i}`} width={usableElementSize} height={usableElementSize} margin={elementMargin}/>
      );
      numYellowsTop -= 1;
    }
    else if(i % 2 === 0)
    {
      topRowCols.push(<Square color="none" isFilled={false} key={`topempty${i}`} width={usableElementSize} height={usableElementSize} margin={elementMargin} />);
    }

    if(i % 2 !== 0 && numRedsTop > 0)
    {
      topRowCols.push(
        <Square color="red" isFilled key={`topred${i}`} width={usableElementSize} height={usableElementSize} margin={elementMargin}/>
      );
      numRedsTop -= 1;
    }
    else if(i % 2 !== 0){
      topRowCols.push(<Square color="none" isFilled={false} key={`topempty${i}`} width={usableElementSize} height={usableElementSize} margin={elementMargin}/>);
    }
  }

  rows.push(
    <View style={styles.row}key='row1' >
      {topRowCols}
    </View>
  );

  const bottomRowCols: JSX.Element[] = [];

  for (let i = 0; i < 5; i++) {
    if(i % 2 === 0 && numYellowsBottom !== 0)
    {
      bottomRowCols.push(
        <Square color="yellow" isFilled key={`topyellow${i}`} width={usableElementSize} height={usableElementSize} margin={elementMargin}/>
      );
      numYellowsBottom -= 1;
    }
    else if(i % 2 === 0 && numYellowsBottom <= 0)
    {
      bottomRowCols.push(<Square color="none" isFilled={false} key={`topempty${i}`} width={usableElementSize} height={usableElementSize} margin={elementMargin}/>);
    }
    if(i % 2 !== 0 && numRedsBottom !== 0)
    {
      bottomRowCols.push(
        <Square color="red" isFilled key={`red${i}`} width={usableElementSize} height={usableElementSize} margin={elementMargin}/>
      );
      numRedsBottom -= 1;
    }
    else if(i % 2 !== 0 && numRedsBottom <= 0){
      bottomRowCols.push(<Square color="none" isFilled={false} key={`topempty${i}`} width={usableElementSize} height={usableElementSize} margin={elementMargin}/>);
    }
  }

  rows.push(
    <View style={styles.row} key='row2'>
      {bottomRowCols}
    </View>
  );

  return (
    <View style={styles.frameWrapper} key='tenFrameWrapper'>
      <View style={styles.tenFrame} key='tenFrame'>
        {rows}
      </View>
    </View>
  );
};

export default GroupTenFrame;

const styles = StyleSheet.create({

  frameWrapper: {
    marginVertical: '2%'
  },

  tenFrame: {
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#20232a',
    borderStyle: 'solid',
    backgroundColor: 'grey',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    display: 'flex',
  },

  row: {
    flexDirection: 'row'
  }

});
